import * as Pinia from "pinia";
import * as Vue from "vue";
import * as VueI18n from "vue-i18n";
import * as VueRouter from "vue-router";

import {
  attachAsyncAppsFromManifest,
  initFederation,
  loadManifest,
} from "@gohighlevel/ghl-module-federation-plugin";

import axios from "axios";
let remoteConfigEnv = {
  development: {
    formSurveyApp: "http://localhost:3012/remoteEntry.js?nocache=true",
    quizResultBuilderApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/quiz-result-builder/remoteEntry.js?nocache=true",
    funnelWebsiteAnalytics:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/funnel-website-analytics/remoteEntry.js?nocache=true",
  },
  staging: {
    formSurveyApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/form-survey/remoteEntry.js?nocache=true",
    quizResultBuilderApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/quiz-result-builder/remoteEntry.js?nocache=true",
    funnelWebsiteAnalytics:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/funnel-website-analytics/remoteEntry.js?nocache=true",
  },
  interop: {
    formSurveyApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/form-survey/remoteEntry.js?nocache=true",
    quizResultBuilderApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/quiz-result-builder/remoteEntry.js?nocache=true",
    funnelWebsiteAnalytics:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/funnel-website-analytics/remoteEntry.js?nocache=true",
  },
  beta: {
    formSurveyApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/form-survey/remoteEntry.js?nocache=true",
    quizResultBuilderApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/quiz-result-builder/remoteEntry.js?nocache=true",
    funnelWebsiteAnalytics:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/funnel-website-analytics/remoteEntry.js?nocache=true",
  },
  production: {
    formSurveyApp:
      "https://appcdn.leadconnectorhq.com/leadgen/form-survey/remoteEntry.js?nocache=true",
    quizResultBuilderApp:
      "https://appcdn.leadconnectorhq.com/leadgen/quiz-result-builder/remoteEntry.js?nocache=true",
    funnelWebsiteAnalytics:
      "https://appcdn.leadconnectorhq.com/leadgen/funnel-website-analytics/remoteEntry.js?nocache=true",
  },
};

const loadCSSFile = () => {
  const manifest = window?.__APP_MANIFEST__;
  if((manifest && manifest?.['tailwindcss']) && !document.querySelector('link[data-manifest-tailwind]')){
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = manifest['tailwindcss'];
    link.setAttribute('data-manifest-tailwind', 'true')
    document.head.appendChild(link)
  }
};

export const initRemoteApps = async () => {
  const env = process.env.NODE_ENV;

  const buildRemotes = (config) =>
    Object.entries(config).map(([key, entry]) => ({
      name: key,
      alias: key,
      entry,
    }));

  const initWithRemotes = (config) => {
    const remoteApps = buildRemotes(config);
    initFederation({
      name: "form-survey-builder-runtime-remote-apps",
      remotes: remoteApps,
      shared: {
        vue: {
          version: Vue.version,
          lib: () => Vue,
          shareConfig: { singleton: true, requiredVersion: "^3.4.30" },
        },
        "vue-i18n": {
          version: "9.13.1",
          lib: () => VueI18n,
          shareConfig: { singleton: true, requiredVersion: "^9.13.1" },
        },
        pinia: {
          version: "2.1.7",
          scope: "default",
          lib: () => Pinia,
          shareConfig: {
            singleton: true,
            requiredVersion: "^2.1.7",
          },
        },
        axios: {
          version: "1.7.2",
          lib: () => axios,
          shareConfig: { singleton: true, requiredVersion: "^1.7.2" },
        },
        "lodash-es": {
          shareConfig: { singleton: true, requiredVersion: "^4.17.21" },
        },
        lodash: {
          shareConfig: { singleton: true, requiredVersion: "^4.17.21" },
        },
        "vue-router": {
          version: "4.5.0",
          lib: () => VueRouter,
          shareConfig: { singleton: true, requiredVersion: "^4.5.0" },
        },
      },
    });
  };

  if (env !== "development" && env !== "staging") {
    await loadManifest(env);
    remoteConfigEnv = attachAsyncAppsFromManifest(remoteConfigEnv[env], env);
    loadCSSFile()
    initWithRemotes(remoteConfigEnv);
   return;
  }
  initWithRemotes(remoteConfigEnv[env]);
};
